import React from 'react';
import { Layout } from 'antd';
import { SlidersOutlined } from '@ant-design/icons';

const { Sider } = Layout;

const SidebarComponent = ({ collapsed, setCollapsed, pathname }) => (
  <Sider
    style={{
      overflow: 'auto',
      height: '100vh',
      position: 'fixed',
      left: 0,
      boxShadow: '2px 0 6px rgba(0,21,41,.35)',
    }}
    collapsible
    collapsed={collapsed}
    onCollapse={() => setCollapsed(!collapsed)}
  >
    <h1 className="pointer blue text-2xl mb-0 text-white" style={{ height: 56 }}>
      <p className="flex justify-center items-center w-full h-full text-white" to="/">
        <SlidersOutlined />
        <span>Project</span>
      </p>
    </h1>
  </Sider>
);

export default SidebarComponent;
